const updateSwatchTabIndex = (carouselContainer) => {
  if (!carouselContainer) return;
  
  const swiperContainer = carouselContainer.querySelector('.swiper');
  if (!swiperContainer) return;
  
  const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
  if (!swiperWrapper) return;
  
  const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
  
  const containerRect = swiperContainer.getBoundingClientRect();
  
  slides.forEach((slide) => {
    const input = slide.querySelector('input[type="radio"]');
    if (!input) return;
    
    const isVisible = isSlideFullyVisible(slide, containerRect);
    
    if (isVisible) {
      input.setAttribute('tabindex', '0');
    } else {
      input.setAttribute('tabindex', '-1');
    }
  });
};

const isSlideFullyVisible = (slide, containerRect) => {
  const slideRect = slide.getBoundingClientRect();
  
  const slideWidth = slideRect.width;
  
  const visibleLeft = Math.max(slideRect.left, containerRect.left);
  const visibleRight = Math.min(slideRect.right, containerRect.right);
  const visibleWidth = Math.max(0, visibleRight - visibleLeft);
  
  const visibilityThreshold = 0.9;
  const visibilityRatio = visibleWidth / slideWidth;
  
  return visibilityRatio >= visibilityThreshold;
};

const setupSwiperListeners = (carouselContainer) => {
  if (!carouselContainer || carouselContainer.hasAttribute('data-swiper-listener-attached')) {
    return;
  }
  
  const swiperContainer = carouselContainer.querySelector('.swiper');
  if (!swiperContainer || !swiperContainer.swiper) return;
  
  const swiper = swiperContainer.swiper;
  
  swiper.on('transitionEnd', () => {
    setTimeout(() => {
      updateSwatchTabIndex(carouselContainer);
    }, 50);
  });
  
  swiper.on('slideChange', () => {
    setTimeout(() => {
      updateSwatchTabIndex(carouselContainer);
    }, 50);
  });
  
  const handleResize = () => {
    updateSwatchTabIndex(carouselContainer);
  };
  
  window.addEventListener('resize', handleResize);
  
  carouselContainer.setAttribute('data-swiper-listener-attached', 'true');
  
  setTimeout(() => {
    updateSwatchTabIndex(carouselContainer);
  }, 50);
};

const setupToggleNextButton = (carouselContainer) => {
  if (!carouselContainer || carouselContainer.hasAttribute('data-toggle-button-attached')) {
    return;
  }
  
  const swiperContainer = carouselContainer.querySelector('.swiper');
  if (!swiperContainer || !swiperContainer.swiper) return;
  
  const swiper = swiperContainer.swiper;
  
  const allNextButtons = Array.from(carouselContainer.querySelectorAll('.ss__carousel__next'));
  const standaloneNextButton = allNextButtons.find((btn) => {
    const wrapper = btn.closest('.ss__carousel__next-wrapper');
    return wrapper && !wrapper.classList.contains('ss__carousel__next-wrapper--hidden');
  });
  
  if (!standaloneNextButton) return;
  
  let movingForward = true;
  
  const isAtBeginning = () => swiper.isBeginning || swiper.activeIndex === 0;
  
  const isAtEnd = () => swiper.isEnd || swiper.activeIndex >= (swiper.slides.length - swiper.params.slidesPerView);
  
  const handleKeyDownCapture = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (movingForward) {
        swiper.slideNext();
        
        setTimeout(() => {
          if (isAtEnd()) {
            movingForward = false;
            standaloneNextButton.setAttribute('aria-label', 'See previous options');
          }
        }, 50);
      } else {
        swiper.slidePrev();
        
        setTimeout(() => {
          if (isAtBeginning()) {
            movingForward = true;
            standaloneNextButton.setAttribute('aria-label', 'See more options');
          }
        }, 50);
      }
    }
  };
  
  swiper.on('slideChange', () => {
    if (isAtEnd() && movingForward) {
      movingForward = false;
      standaloneNextButton.setAttribute('aria-label', 'See previous options');
    } else if (isAtBeginning() && !movingForward) {
      movingForward = true;
      standaloneNextButton.setAttribute('aria-label', 'See more options');
    }
  });
  
  standaloneNextButton.removeEventListener('keydown', handleKeyDownCapture, true);
  standaloneNextButton.addEventListener('keydown', handleKeyDownCapture, true);
  
  carouselContainer.setAttribute('data-toggle-button-attached', 'true');
};

export const fixProductCardSwatchCarouselA11y = () => {
  const carouselButtons = Array.from(document.querySelectorAll('.ss__carousel__prev, .ss__carousel__next'));
  
  carouselButtons.forEach((button) => {
    if (button.hasAttribute('data-accessibility-fixed')) {
      return;
    }
    
    if (!button.hasAttribute('tabindex')) {
      button.setAttribute('tabindex', '0');
    }
    
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }
    };
    
    button.removeEventListener('keydown', handleKeyDown);
    button.addEventListener('keydown', handleKeyDown);
    
    if (!button.hasAttribute('role')) {
      button.setAttribute('role', 'button');
    }
    
    if (!button.hasAttribute('aria-label')) {
      const isPrev = button.classList.contains('ss__carousel__prev');
      const isNext = button.classList.contains('ss__carousel__next');
      
      if (isPrev) {
        button.setAttribute('aria-label', 'See previous options');
      } else if (isNext) {
        button.setAttribute('aria-label', 'See more options');
      }
    }
    
    const isDisabled = button.classList.contains('swiper-button-disabled') || 
                     button.getAttribute('aria-disabled') === 'true';
    button.setAttribute('aria-disabled', isDisabled.toString());
    
    if (isDisabled) {
      button.setAttribute('tabindex', '-1');
    }
    
    button.setAttribute('data-accessibility-fixed', 'true');
  });
  
  const setupCarousels = () => {
    const carouselContainers = Array.from(document.querySelectorAll('.ss__carousel, .ss__actions-color-carousel'));
    
    if (carouselContainers.length === 0) {
      setTimeout(setupCarousels, 200);
      return;
    }
    
    carouselContainers.forEach((container) => {
      const swiperContainer = container.querySelector('.swiper');
      if (swiperContainer) {
        if (swiperContainer.swiper) {
          setupSwiperListeners(container);
          setupToggleNextButton(container);
        } else {
          const checkSwiper = setInterval(() => {
            if (swiperContainer.swiper) {
              clearInterval(checkSwiper);
              setupSwiperListeners(container);
              setupToggleNextButton(container);
            }
          }, 100);
          
          setTimeout(() => clearInterval(checkSwiper), 500);
        }
      }
    });
  };
  
  setTimeout(setupCarousels, 300);
};

export const initSearchSpringAccessibility = () => {
  fixProductCardSwatchCarouselA11y();
  
  const observer = new MutationObserver((mutations) => {
    let shouldFix = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList?.contains('ss__carousel__prev') || 
                node.classList?.contains('ss__carousel__next') ||
                node.querySelector?.('.ss__carousel__prev, .ss__carousel__next')) {
              shouldFix = true;
            }
          }
        });
      }
    });
    
    if (shouldFix) {
      fixProductCardSwatchCarouselA11y();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  return observer;
};

export default {
  fixProductCardSwatchCarouselA11y,
  initSearchSpringAccessibility
};
